import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PayLocationIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M12 5.60999C9.35 5.60999 7.19 7.76999 7.19 10.43C7.19 13.09 9.35 15.24 12 15.24C14.65 15.24 16.82 13.08 16.82 10.43C16.82 7.77999 14.66 5.60999 12 5.60999ZM12 13.99C10.03 13.99 8.44 12.39 8.44 10.43C8.44 8.46999 10.04 6.85999 12 6.85999C13.96 6.85999 15.57 8.45999 15.57 10.43C15.57 12.4 13.97 13.99 12 13.99Z"
        fill={color}
      />
      <path
        d="M12 0.25C6.39001 0.25 1.82001 4.82 1.82001 10.43C1.82001 17.55 10.52 23.75 12 23.75C13.48 23.75 22.18 17.55 22.18 10.43C22.18 4.82 17.61 0.25 12 0.25ZM12 22.24C10.63 21.8 3.32001 16.45 3.32001 10.43C3.32001 5.64 7.21001 1.75 12 1.75C16.79 1.75 20.68 5.64 20.68 10.43C20.68 16.45 13.37 21.8 12 22.24Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

PayLocationIcon.displayName = 'PayLocationIcon';
